import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import * as day from 'dayjs';
import { IPbisType } from 'libs/domain';
import { ReplaySubject } from 'rxjs';

import { CHECK_IN_FIELDS, CHECK_IN_GROUP, MyClassMessages } from '../../constants/tt-my-class.constants';
import { AssignmentType } from '../../types/tt-my-class.types';

@Component({
  selector: 'mg-tt-check-in-fields',
  templateUrl: './tt-check-in-fields.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TtCheckInFieldsComponent implements OnInit, OnDestroy {
  @Input() form: UntypedFormGroup;
  @Input() type: IPbisType;

  private _destroyedSubject = new ReplaySubject<void>(1);
  public today = day();
  public group: UntypedFormGroup;
  public CHECK_IN_FIELDS = CHECK_IN_FIELDS;
  public MESSAGES = MyClassMessages;

  constructor(private _fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    this._setFormGroup();
  }

  ngOnDestroy(): void {
    this.form.removeControl(AssignmentType.CHECK_IN);
    this.form.updateValueAndValidity();
    this._destroyedSubject.next();
    this._destroyedSubject.complete();
  }

  private _setFormGroup() {
    this.group = this._fb.group(CHECK_IN_GROUP());
    this.form.addControl(AssignmentType.CHECK_IN, this.group);
    this.form.updateValueAndValidity();
  }
}
